import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute } from "PrivateRoute";
import AuthLayout from "layouts/auth";
import SuperUser from "layouts/superuser";

const CustomerProposalView = React.lazy(() => import("views/portal/quotation/CustomerProposalView"));
const CustomerProposalConfirmation = React.lazy(() => import("views/portal/quotation/CustomerProposalConfirmation"));

function getFaviconElement(): HTMLLinkElement | null {
  return document.getElementById("favicon") as HTMLLinkElement | null;
}

const App = () => {
  useEffect(() => {
    const storedFavicon = localStorage.getItem("favicon");
    const storedTitle = localStorage.getItem("title");

    if (storedFavicon) {
      const favicon = getFaviconElement();
      favicon.href = storedFavicon;
    }

    if (storedTitle) {
      document.title = storedTitle;
    }
  }, []);
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="superuser/*"
        element={
          <PrivateRoute>
            <SuperUser />
          </PrivateRoute>
        }
      />
      <Route
        path="portal/quotations/:id"
        element={
          <Suspense fallback={<div className="portal-loading"><div className="portal-loading-spinner" /></div>}>
            <CustomerProposalView />
          </Suspense>
        }
      />
      <Route
        path="portal/quotations/:id/confirmation"
        element={
          <Suspense fallback={<div className="portal-loading"><div className="portal-loading-spinner" /></div>}>
            <CustomerProposalConfirmation />
          </Suspense>
        }
      />
      <Route path="/" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default App;
